import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { app } from "./initialize-app";

export const functions = getFunctions(app);

process.env.NODE_ENV !== "production" &&
  process.env.NEXT_PUBLIC_FIREBASE_USE_EMULATOR === "true" &&
  connectFunctionsEmulator(functions, "0.0.0.0", 5001);
